import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import TransactionServices from "../TransactionServices";

export default function SpotifyExchangeRateBox(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }

    let [spotifyExchangeRate, setSpotifyExchangeRate] = useState<any[]>([]);
    const SpotifyRate = () => {
        TransactionServices.getSpotifyExchangeRate({}).then((res: any) => {
            console.log(res)
            spotifyExchangeRate = res
            setSpotifyExchangeRate(res)
            console.log("test for spotify exchange rate button")
        })
    }

    useEffect(() => {
        SpotifyRate()
    }, [param.param])



    return (
        <div className="ws-6">
            <Modal open={param.param} onClose={() => returnValue(2)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >

                <div className="box mb ">
                    <div className="box mb ">
                        <div className="box-header-main">
                            <h2 className="ws-12 m0 pl full-width"><i className="icon-file-add"></i> Exchange Rate</h2>
                        </div>
                        <div className="box-content">
                            <div className="row-fluid">
                                <form className="form-horizontal  ng-pristine ng-invalid ng-invalid-required">
                                    <div className="ws-4">
                                        <div className="form-format">
                                            <label className="control-label">Currency Sign</label>
                                            <div className="label-entries">
                                                <input type="text" name="txtCurr" id="txtCurr" ng-model="txtData.txtCurr" className="ws-10 ng-pristine ng-untouched ng-invalid ng-invalid-required" placeholder="Enter Currency Sign" data-ng-required="true" required />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ws-4">
                                        <div className="form-format">
                                            <label className="control-label">Exchange Rate</label>
                                            <div className="label-entries">
                                                <input type="number" name="txtExch" id="txtExch" ng-model="txtData.txtExch" className="ws-10 ng-pristine ng-untouched ng-invalid ng-invalid-required" placeholder="Enter Exchange Rate" data-ng-required="true" required />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="alert alert-danger  ng-hide" data-ng-show="addNewTerrCurr">Enter a correct currency sign of 3 characters and a floating exchange rate </div>
                            <div className="alert alert-success  ng-hide" data-ng-show="deleteSuccess">Exchange Rate has been removed </div>
                            <div className="alert alert-success  ng-hide" data-ng-show="addSuccess">Exchange Rate has been added successfully </div>
                        </div>
                        <div className="box-footer">
                            <a className="btn btn-pink" data-ng-click="reset()">
                                <i className="icon-reload"></i> Reset
                            </a>
                            <a className="icon-btn info" data-ng-click="addSpotifyExchangeRate(txtData.txtCurr, txtData.txtExch)">
                                <i className="icon-plus1"></i> Save
                            </a>
                        </div>
                    </div>

                    <div className="box-content">
                        <div className="row-fluid">
                            <div className="table-responsive_big">
                                <div className="alert alert-success  ng-hide" data-ng-hide="currSign.length &gt; 0">No file uploaded for this month, year and territory </div>
                                <table className="table" data-ng-show="currSign.length &gt; 0">
                                    <thead>
                                        <tr>
                                            <th>Currency Sign</th>
                                            <th>Exchange Rate</th>
                                            <th>Operation</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr data-ng-repeat="cs in currSign" >
                                            <td >EUR</td>
                                            <td >1.1722576</td>
                                            <td>
                                                <a title="Edit" ng-click="exchRateEdit(cs)" className="btn icon-btn edit"><i className="icon-edit"></i></a>
                                                <a title="Delete" ng-click="deleteSpotifyExchangeRate(cs)" className="btn icon-btn delete"><i className="icon-trashcan"></i></a>
                                            </td>
                                        </tr><tr data-ng-repeat="cs in currSign" >
                                            <td >GBP</td>
                                            <td >1</td>
                                            <td>
                                                <a title="Edit" ng-click="exchRateEdit(cs)" className="btn icon-btn edit"><i className="icon-edit"></i></a>
                                                <a title="Delete" ng-click="deleteSpotifyExchangeRate(cs)" className="btn icon-btn delete"><i className="icon-trashcan"></i></a>
                                            </td>
                                        </tr><tr data-ng-repeat="cs in currSign" >
                                            <td >USD</td>
                                            <td >1.2733688</td>
                                            <td>
                                                <a title="Edit" ng-click="exchRateEdit(cs)" className="btn icon-btn edit"><i className="icon-edit"></i></a>
                                                <a title="Delete" ng-click="deleteSpotifyExchangeRate(cs)" className="btn icon-btn delete"><i className="icon-trashcan"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="clearfix">
                                <ul className="pull-left pagination ng-isolate-scope ng-valid ng-hide" total-items="fileHistoryCount" ng-model="pageNumberFileHistory" max-size="3" ng-change="fileHistoryPageChanged(searchDatehistory, selectTerritoryList, pageNumberFileHistory)" data-ng-show="fileHistoryCount &gt; 10">
                                    <li ng-if="::directionLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page - 1, $event)" >Previous</a></li>
                                    <li ng-repeat="page in pages track by $index" ng-className="{active: page.active,disabled: ngDisabled&amp;&amp;!page.active}" className=" active"><a href="" ng-click="selectPage(page.number, $event)" >1</a></li>
                                    <li ng-if="::directionLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page + 1, $event)" >Next</a></li>

                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="box-footer">
                        <button className="btn icon-btn delete btn-sm " data-ng-click="closeExchRate()"><i className="icon-close"></i> Close</button>
                    </div>

                </div>

            </Modal>
        </div>
    )
}